export const EExchangeTypes = {
  ALL: 'network',
  FUNCTION: 'function',
  TEAM: 'team',
  USER: 'user',
};
